import React, { useId } from "react";

export default function DynamicFrameworkSection({ aiData }) {
    if (!aiData?.framework) return null;

  return (
    <section className="dynamic-framework-section">
      <div className="container">
        <div className="dynamic-framework-heading text-center">
          <span className="main-title">{aiData?.framework?.eyebrow}</span>
          <h2 className="heading">{aiData?.framework?.title}</h2>
        </div>
        <ol className="dynamic-framework-steps">
          {aiData?.framework?.steps.map((step, index) => (
            <li className="dynamic-framework-step" key={index}>
              <span className="dynamic-framework-number" aria-hidden="true">
                {String(index + 1).padStart(2, "0")}
              </span>
              <h3>{step?.title}</h3>
              <p>{step?.description}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
